import { render, staticRenderFns } from "./NotificationRow.vue?vue&type=template&id=f6ed9d08&scoped=true"
import script from "./NotificationRow.vue?vue&type=script&lang=js"
export * from "./NotificationRow.vue?vue&type=script&lang=js"
import style0 from "./NotificationRow.vue?vue&type=style&index=0&id=f6ed9d08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ed9d08",
  null
  
)

export default component.exports